import { useMemo, useState } from "react";
import client from "libs/client";
import { GameHistoryFeed } from "./GameHistoryFeed";
import { GameHistorySubTabs } from "./GameHistorySubTabs";
import {
	GAME_HISTORY_SUB_TAB_API_TYPE,
	GameHistorySubTabId,
	gameHistoryEmptyMessageKey,
	gameHistoryShowsAddForm,
	type GameHistorySubTab,
} from "./gameHistorySubTabConfig";
import "./DiscoverGameHistoryTab.css";

interface DiscoverGameHistoryTabProps {
	gameId: number;
}

export function DiscoverGameHistoryTab({ gameId }: DiscoverGameHistoryTabProps) {
	const [subTab, setSubTab] = useState<GameHistorySubTab>(GameHistorySubTabId.All);

	const { data: gameStatusOptionsResp } = client.getDiscoverGamesV2GameStatusOptions.useQuery({});

	const gameStatusLabels = useMemo(() => {
		const labels: Record<string, string> = {};
		for (const option of gameStatusOptionsResp?.data ?? []) {
			if (option.value !== null && option.value !== undefined) {
				labels[String(option.value)] = option.label ?? String(option.value);
			}
		}
		return labels;
	}, [gameStatusOptionsResp]);

	return (
		<div className="discoverGameHistory">
			<GameHistorySubTabs subTab={subTab} onSubTabChange={setSubTab} />

			<GameHistoryFeed
				key={subTab}
				gameId={gameId}
				apiType={GAME_HISTORY_SUB_TAB_API_TYPE[subTab]}
				showAddForm={gameHistoryShowsAddForm(subTab)}
				emptyMessageKey={gameHistoryEmptyMessageKey(subTab)}
				gameStatusLabels={gameStatusLabels}
			/>
		</div>
	);
}
